import { Card, Descriptions, Divider, Space } from 'antd';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { appRoute } from 'app/railways/router/routes';

import { TTicketOrder } from '../../core/tickets-order';
import { OrderStatusLabel } from '../../ui/order-status-label';

type DetailsOrderProps = {
  order: TTicketOrder;
};

export const DetailsOrder = observer(({ order }: DetailsOrderProps) => {
  const mainTicket = order.tickets.find((t) => t.mainTicketId == undefined);

  return (
    <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
      <Card size="small" title="Общее">
        <Descriptions bordered size="small" column={1}>
          <Descriptions.Item
            label="ID заказа"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {order.id || ''}
          </Descriptions.Item>

          <Descriptions.Item
            label="Статус"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {order.status !== undefined ? (
              <>
                <OrderStatusLabel status={order.status} />
                <Divider type="vertical" />
                {order.description}
              </>
            ) : null}
          </Descriptions.Item>

          <Descriptions.Item
            label="Дата заказа"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {order.date ? new Date(order.date).toLocaleString() : ''}
          </Descriptions.Item>

          <Descriptions.Item
            label="Сумма заказа"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {order.paySumm ? `${order.paySumm} ֏` : ''}
          </Descriptions.Item>

          <Descriptions.Item
            label="Станция отправления"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {mainTicket?.stationFrom.nameRu ? (
              <>
                {mainTicket?.stationFrom.nameRu}
                <Divider type="vertical" />
                {new Date(mainTicket?.departureTime || 0).toLocaleString()}
              </>
            ) : null}
          </Descriptions.Item>

          <Descriptions.Item
            label="Станция прибытия"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {mainTicket?.stationTo.nameRu ? (
              <>
                {mainTicket?.stationTo.nameRu}
                <Divider type="vertical" />
                {new Date(mainTicket?.arrivalTime || 0).toLocaleString()}
              </>
            ) : null}
          </Descriptions.Item>

          <Descriptions.Item
            label="Рейс"
            labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
          >
            {order.tripId ? (
              <>
                <Link to={appRoute.TRIP.buildPath({ id: order.tripId })}>
                  Открыть рейс
                </Link>
                <Divider type="vertical" />
                ID: {order.tripId}
              </>
            ) : null}
          </Descriptions.Item>
        </Descriptions>
      </Card>

      <Card size="small" title="Тарифы">
        <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
          {order.tickets.map((ticket) => (
            <Descriptions key={ticket.id} bordered size="small" column={1}>
              <Descriptions.Item
                label="ID тарифа"
                labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
              >
                {ticket.tariffId}
              </Descriptions.Item>

              <Descriptions.Item
                label="Стоимость"
                labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
              >
                {ticket.paySumm} ֏
              </Descriptions.Item>

              {ticket.refundDate && (
                <Descriptions.Item
                  label="Дата возврата"
                  labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
                >
                  {ticket.refundDate} ֏
                </Descriptions.Item>
              )}

              {ticket.wagonNum && (
                <Descriptions.Item
                  label="Номер вагона"
                  labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
                >
                  {ticket.wagonNum}
                </Descriptions.Item>
              )}

              {ticket.seatNum && (
                <Descriptions.Item
                  label="Номер места"
                  labelStyle={{ width: '1%', whiteSpace: 'nowrap' }}
                >
                  {ticket.seatNum}
                </Descriptions.Item>
              )}
            </Descriptions>
          ))}
        </Space>
      </Card>
    </Space>
  );
});
